export const nameOf = <T extends unknown>(key: keyof T): string => key.toString();
